import { DatePipe } from '@angular/common';
import { ElementRef, Input, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ItemCateSalesPieChartModel, SalesItemAnalysisModelList } from 'src/app/models/charts/ItemCateSalesPieChartModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { CustomReportService } from 'src/app/services/ReportService/CustomReport.service';
import { SnackBarService, SnackBar_Config } from 'src/app/services/SnackBar/SnackBarService.service';
import * as Chart from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
import {formatNumber} from '@angular/common';


@Component({
  selector: 'app-analysis-item-dialog',
  templateUrl: './analysis-item-dialog.component.html',
  styleUrls: ['./analysis-item-dialog.component.css']
})
export class AnalysisItemDialogComponent implements OnInit {

  TAG = "AnalysisItemDialogComponent";

  @Input() itemID: string;
  @Input() itemName: string;
  @Input() selectDate;
  @Input() selectDateEnd;

  isLoading = false;
  @ViewChild('salesItemGenderChart')
  salesItemGenderChartElement: ElementRef<HTMLCanvasElement>;

  @ViewChild('salesItemGenderQtyChart')
  salesItemGenderQtyChartElement: ElementRef<HTMLCanvasElement>;

  @ViewChild('salesItemPatientTypeChart')
  salesItemPatientTypeChartElement: ElementRef<HTMLCanvasElement>;

  @ViewChild('salesItemPatientTypeChartTotal')
  salesItemPatientTypeChartTotalElement:ElementRef<any>;

  @ViewChild('salesItemGenderChartTotal')
  salesItemGenderChartTotalElement:ElementRef<any>;
  

  salesItemGenderChart: any;
  salesItemGenderQtyChart: any;
  salesItemPatientTypeChart: any;
  itemBillDesc = "";
  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    public datePipe: DatePipe,
    private customReportService: CustomReportService,
    private snackBarService: SnackBarService,
    readonly translate: TranslateService,
  ) {
    let currentLanguage = localStorage.getItem('currentLanguage');
    translate.use(currentLanguage);
  }

  ngOnInit() {
    this.log.i(this.TAG, "itemID = " + this.itemID);
    this.newSalesItemGenderChart(this.itemID);
  }

  newSalesItemGenderChart(itemID) {
    if (!this.checkIsLoading()) {
      var shopID = NavigationComponent.selectedShopID.toString();

      //   var canvas = <HTMLCanvasElement>document.getElementById('salesItemGenderChart');
      const canvas = this.salesItemGenderChartElement.nativeElement;
      var ctx = canvas.getContext('2d');


      //var selectDate = new Date((new Date().getTime()));
      const currentDateStr = this.datePipe.transform(this.selectDate, 'yyyy-MM-dd');

      const currentDateEndStr = this.datePipe.transform(this.selectDateEnd, 'yyyy-MM-dd');

      const searchParaJSON = [];
      const searchParaJSONRaw = {
        itemID: this.itemID
      };
      searchParaJSON.push(searchParaJSONRaw);

      this.isLoading = true;
      this.itemBillDesc = "";

      this.customReportService.getAnalysisReportData(shopID, 4, currentDateStr, currentDateEndStr, searchParaJSON)
        .subscribe((data: SalesItemAnalysisModelList) => {

          this.isLoading = false;

          var labelArray = [];
          var totalBillQtyArray = [];
          var totalSalesQtyArray = [];
          var totalPatientQtyArray = [];

          var extraText = "<table class='analysisItemDialog'><tr>"
            + "<th style='text-align: right'>" + this.getTranslate("cGender") + "</th>"
            + "<th style='text-align: center'>" + this.getTranslate("analysisReport_CountOfDifferentPatient") + "</th>"
            + "<th style='text-align: center'>" + this.getTranslate("analysisReport_CountOfBillSales") + "</th>"
            + "<th style='text-align: center'>" + this.getTranslate("analysisReport_CountOfItemSales") + "</th>"
            + "</tr>";
            
          this.itemBillDesc = this.getTranslate("analysisReport_CountOfBill") +" " + data.totalBillQty + "\n" + this.getTranslate("analysisReport_CountOfDifferentPatient")+" " + data.countOfPatient;

          for (var pp = 0; pp < data.genderByTotalBillList.length; pp++) {
            var targetData = data.genderByTotalBillList[pp];
            labelArray.push(targetData.genderChineseName);
            //  labelArray.push(targetData.itemCateName);
            totalBillQtyArray.push(targetData.totalBillQty);
            totalSalesQtyArray.push(targetData.totalItemSalesQty);
            totalPatientQtyArray.push(targetData.countOfPatient);

            extraText +=
              "<tr>"
              + "<td style='text-align: right'>" + targetData.genderChineseName + "</td>"
              + "<td>" + targetData.countOfPatient + "</td>"
              + "<td>" + targetData.totalBillQty + "</td>"
              + "<td>" + targetData.totalItemSalesQty + "</td>"
              + "</tr>";

              if(pp+1>=data.genderByTotalBillList.length){
                extraText +=
                "<tfoot><tr>"
                + "<td style='text-align: right'>" +  this.getTranslate("analysisReport_total") + "</td>"
                + "<td>" + totalPatientQtyArray.reduce((acc, cur) => acc + Number(cur), 0) + "</td>"
                + "<td>" + totalBillQtyArray.reduce((acc, cur) => acc + Number(cur), 0) + "</td>"
                + "<td>" + totalSalesQtyArray.reduce((acc, cur) => acc + Number(cur), 0) + "</td>"
                + "</tr></tfoot>";
              }
          }
          extraText += "</table>";


          this.salesItemGenderChartTotalElement.nativeElement.innerHTML =
          this.getTranslate("employeeLeaveModel_leaveDate") + currentDateStr + " - " + currentDateEndStr + "\n" +
            
            extraText;

          var totalRecord = labelArray.length;

          const chartData = {
            labels: labelArray,
            //  labels: ,
            datasets: [
              {
              label: 'Bill Qty',
              data: totalBillQtyArray,
              backgroundColor: this.getRandomColor(totalRecord),
              hoverOffset: 4
              }
            ]
          };


          if (this.salesItemGenderChart) {
            this.salesItemGenderChart.destroy();
          }

          
          this.salesItemGenderChart = new Chart(ctx, {
            type: 'pie',
            data: chartData,
            options: {
              responsive: true,
              plugins: {
                labels: [{
                  // render 'label', 'value', 'percentage', 'image' or custom function, default is 'percentage'
                  render: function (args) {
                    return args.label + " : " + args.percentage + '%';
                  },
                  // precision for percentage, default is 0
                  precision: 0,
                  // identifies whether or not labels of value 0 are displayed, default is false
                  showZero: false,
                  // font size, default is defaultFontSize
                  fontSize: 16,
                  fontColor: '#000',
                  fontStyle: 'normal',
                  textShadow: false,
                  shadowBlur: 10,
                  shadowOffsetX: -5,
                  shadowOffsetY: 5,
                  shadowColor: 'rgba(255,0,0,0.75)',
                  arc: false,
                  position: 'outside',
                  overlap: true,
                  showActualPercentages: true,
                  outsidePadding: 4,
                  textMargin: 4
                }]
              },
              title: {
                display: true,
                text: this.getTranslate("analysisReport_CountOfSalesBillGenderQty")
              }
            }
          });


       
          this.createSalesItemGenderQtyChart(data,labelArray,totalSalesQtyArray,totalRecord);

          /******
           * 
           * salesItemPatientTypeChart start
           */
          this.createSalesItemPatientTypeChart(data);







        },
          err => {
            this.isLoading = false;
          });
    }
  }

  createSalesItemGenderQtyChart(data: SalesItemAnalysisModelList,labelArray,totalSalesQtyArray,totalRecord){
    if(this.salesItemGenderQtyChart){
      this.salesItemGenderQtyChart.destroy();
    }


    const chartData2 = {
      labels: labelArray,
      //  labels: ,
      datasets: [
        {
        label: 'Bill Qty',
        data: totalSalesQtyArray,
        backgroundColor: this.getRandomColor(totalRecord),
        hoverOffset: 4
        }
      ]
    };

    const canvas2 = this.salesItemGenderQtyChartElement.nativeElement;
    var context = canvas2.getContext('2d');
    this.salesItemGenderQtyChart = new Chart(context, {
      type: 'pie',
      data: chartData2,
      options: {
        responsive: true,
        plugins: {
          labels: [{
            render: function (args) {
              return args.label + " : " + args.percentage + '%';
            },
            precision: 0,
            showZero: false,
            fontSize: 16,
            fontColor: '#000',
            fontStyle: 'normal',
            textShadow: false,
            shadowBlur: 10,
            shadowOffsetX: -5,
            shadowOffsetY: 5,
            shadowColor: 'rgba(255,0,0,0.75)',
            arc: false,
            position: 'outside',
            overlap: true,
            showActualPercentages: true,
            outsidePadding: 4,
            textMargin: 4
          }]
        },
        title: {
          display: true,
          text: this.getTranslate("analysisReport_CountOfSalesItemGenderQty")
        }
      }
    });

  }

  createSalesItemPatientTypeChart(data: SalesItemAnalysisModelList) {
    //  var canvas = <HTMLCanvasElement>document.getElementById('salesItemPatientTypeChart');
    var canvas = this.salesItemPatientTypeChartElement.nativeElement;
    var ctx = canvas.getContext('2d');

    var labelArray = [];
    var totalQtyArray = [];
    var billQtyArray = [];

    var extraText = "<table class='analysisItemDialog'><tr>"
      + "<th style='text-align: right'>" + this.getTranslate("tPatient_pTypeDesc") + "</th>"
      + "<th style='text-align: center'>" + this.getTranslate("analysisReport_CountOfDifferentPatient") + "</th>"
      + "<th style='text-align: center'>" + this.getTranslate("analysisReport_CountOfBillSales") + "</th>"
      + "<th style='text-align: center'>" + this.getTranslate("analysisReport_averagePatient") + "</th>"
      + "</tr>";
   // this.itemBillDesc = "總單數 :" + data.totalBillQty + "\n" + "購買人數(不計算重複購買) :" + data.countOfPatient;
    this.itemBillDesc = this.getTranslate("analysisReport_CountOfBill") +" "+ data.totalBillQty + "\n" + this.getTranslate("analysisReport_CountOfDifferentPatient")+" " + data.countOfPatient;

    for (var pp = 0; pp < data.salesForPatientList.length; pp++) {
      var targetData = data.salesForPatientList[pp];
      labelArray.push(targetData.patientTypeDesc);
      totalQtyArray.push(targetData.countOfPatient);
      billQtyArray.push(targetData.patientTypeBillQty);

      extraText +=
        "<tr>"
        + "<td style='text-align: right'>" + targetData.patientTypeDesc + "</td>"
        + "<td>" + targetData.countOfPatient + "</td>"
        + "<td>" + targetData.patientTypeBillQty + "</td>"
        + "<td>" + formatNumber((targetData.patientTypeBillQty/targetData.countOfPatient), 'en-US', '1.2-2')+ "</td>"
        + "</tr>";

        if(pp+1>=data.salesForPatientList.length){
          extraText +=
          "<tfoot><tr>"
          + "<td style='text-align: right'>" +  this.getTranslate("analysisReport_total") + "</td>"
          + "<td>" + totalQtyArray.reduce((acc, cur) => acc + Number(cur), 0) + "</td>"
          + "<td>" + billQtyArray.reduce((acc, cur) => acc + Number(cur), 0) + "</td>"
          + "</tr></tfoot>";
        }
    }

    extraText += "</table>";

    if (this.salesItemPatientTypeChart) {
      this.salesItemPatientTypeChart.destroy();
    }

    const currentDateStr = this.datePipe.transform(this.selectDate, 'yyyy-MM-dd');

    const currentDateEndStr = this.datePipe.transform(this.selectDateEnd, 'yyyy-MM-dd');
    
    this.salesItemPatientTypeChartTotalElement.nativeElement.innerHTML =
    this.getTranslate("employeeLeaveModel_leaveDate") + currentDateStr + " - " + currentDateEndStr + "\n" +
      extraText;
    var totalRecord = labelArray.length;

    const chartData = {
      labels: labelArray,
      //  labels: ,
      datasets: [{
        label: '產品服務分類',
        data: totalQtyArray,
        backgroundColor: this.getRandomColor(totalRecord),
        hoverOffset: 4
      }]
    };

    this.salesItemGenderChart = new Chart(ctx, {
      type: 'doughnut',
      data: chartData,
      options: {
        responsive: true,
        // legend: {
        //   position: "right",
        //   align: "middle"

        // },
        plugins: {
          labels: [{
            // render 'label', 'value', 'percentage', 'image' or custom function, default is 'percentage'
            render: function (args) {
              return args.label + " : " + args.percentage + '%';
            },
            // precision for percentage, default is 0
            precision: 0,
            // identifies whether or not labels of value 0 are displayed, default is false
            showZero: false,
            // font size, default is defaultFontSize
            fontSize: 16,

            // font color, can be color array for each data or function for dynamic color, default is defaultFontColor
            fontColor: '#000',
            //   fontColor: this.getTextColor(chartData.datasets[0].backgroundColor),
            // font style, default is defaultFontStyle
            fontStyle: 'normal',
            textShadow: false,
            shadowBlur: 10,
            shadowOffsetX: -5,
            shadowOffsetY: 5,

            shadowColor: 'rgba(255,0,0,0.75)',

            // draw label in arc, default is false
            // bar chart ignores this
            arc: false,
            position: 'outside',

            overlap: true,
            // show the real calculated percentages from the values and don't apply the additional logic to fit the percentages to 100 in total, default is false
            showActualPercentages: true,
            outsidePadding: 4,
            textMargin: 4
          }
          ]
        },
        title: {
          display: true,
          text: this.getTranslate("analysisReport_SalesItemPatientTypeGender")
        },

      }
 
    });

  }

  checkIsLoading() {
    if (this.isLoading) {
      this.snackBarService.showMsg("Loading. Please wait", SnackBar_Config.VerticalPosition_Bottom, SnackBar_Config.Horizontal_Center);
      return true;
    }
    return false;
  }

  // tabLoadTimes: Date[] = [];

  // getTimeLoaded(index: number) {
  //   this.log.i(this.TAG,"do getTimeLoaded");
  //   if (!this.tabLoadTimes[index]) {
  //     this.tabLoadTimes[index] = new Date();
  //   }

  //   return this.tabLoadTimes[index];
  // }

  getRandomColor(total: number): string[] {

    var array = [];
    var letters = '0123456789ABCDEF';

    for (var p = 0; p < total; p++) {
      var hexColor = '#';
      for (var i = 0; i < 6; i++) {
        hexColor += letters[Math.floor(Math.random() * 16)];
      }
      var rgb = this.ConvertHexToRGBA(hexColor, 0.7);
      array.push(rgb);
    }

    return array;
  }

  public ConvertHexToRGBA(hex: string, opacity?: number): string {
    opacity = opacity || 1;

    opacity < 0 ? opacity = 0 : opacity = opacity;
    opacity > 1 ? opacity = 1 : opacity = opacity;

    hex = hex.replace('#', '');

    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';

  }

  getTranslate(key: string) {
    var returnDisplayMsg: string = "";
    this.translate.get(key).subscribe((res: string) => {
      returnDisplayMsg = res;
    });
    return returnDisplayMsg;
  }

}
